import { Link } from '@tanstack/react-router'
import { Button } from '@/components/ui/button'
import { MSection, SectionHeader } from '@/components/marketing/section'
import { TextLink } from '@/components/marketing/text-link'
import { StartFreeButton } from '@/components/marketing/free-plan-cta'
import { useFreePlan } from '@/hooks/use-free-plan'
import { tiers } from '@/lib/plans'

export function Pricing({ tone = 'raised' }: { tone?: 'default' | 'raised' }) {
  const free = useFreePlan()
  return (
    <MSection id="pricing" tone={tone}>
      <div className="flex flex-col items-center gap-4">
        <SectionHeader
          align="center"
          title="Pricing"
          lead="No “contact us” pricing. What you see is what you pay. 30-day money-back guarantee on paid plans."
        />
        <TextLink to="/pricing">Compare plans in detail</TextLink>
      </div>
      {free.isOpen && (
        <div className="mx-auto mt-10 flex max-w-3xl flex-col items-start gap-4 rounded-lg border border-border bg-card p-6 sm:flex-row sm:items-center sm:justify-between">
          <div>
            <h3 className="text-lg font-semibold text-foreground">Free plan</h3>
            <p className="mt-1 text-[15px] text-body">
              <span className="num">{free.monitors}</span> monitors checked every <span className="num">{free.intervalSeconds}</span> seconds from{' '}
              {free.location}. HTTP and keyword checks, email and one chat channel, no credit card.
            </p>
          </div>
          <StartFreeButton variant="outline" className="shrink-0" />
        </div>
      )}
      <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-3">
        {tiers.map((t) => {
          const featured = t.plan === 'pro'
          return (
            <article
              key={t.plan}
              className={`flex flex-col rounded-lg border bg-card p-6 ${featured ? 'border-primary shadow-raised' : 'border-border'}`}
            >
              <h3 className="text-lg font-semibold text-foreground">{t.name}</h3>
              <p className="mt-1 text-sm text-muted-foreground">{t.description}</p>
              <p className="mt-5 num">
                <span className="text-4xl font-semibold tracking-tight text-foreground">${t.monthlyPrice}</span>
                <span className="text-sm text-muted-foreground"> /mo</span>
              </p>
              <ul className="mt-5 flex-1 space-y-2 text-[15px] text-body">
                {t.features
                  .filter((f) => f.included)
                  .slice(0, 4)
                  .map((f) => (
                    <li key={f.name}>{f.name}</li>
                  ))}
              </ul>
              <Button variant={featured ? 'default' : 'outline'} className="mt-6 h-10" asChild>
                <Link to="/signup" search={{ plan: t.plan, interval: 'monthly' }}>
                  Choose {t.name}
                </Link>
              </Button>
            </article>
          )
        })}
      </div>
    </MSection>
  )
}
